export const routes: AppRoutes = {
  dashboard: {
    path: '/',
    alias: '/my-abnamro/mortgages/interest-rates',
    name: 'dashboard'
  }
};

export type AppRoutes = Record<string, AppRoute>;

// export type AppRoute = Omit<RouteRecordRaw, 'component'>;
export interface AppRoute {
  readonly path: string;
  readonly alias: string;
  readonly name: string;
  readonly props?: boolean;
}
